import {
  faPlus,
  faList,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { 
  setCurrentUser,
  resetUserMaster,
} from "../../state/userMasterSlice.js" 
import { apiRoute, linksUrl } from "../../constants/enum.js"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks.jsx"
import { 
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable, 
} from "../../components/index.js" 
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable.jsx"

function UserMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { selectedClient } = useSelector((state) => state.clientMaster)

  const exportColumns = [
    { uid: "UserId", name: "User Id" },
    { uid: "FirstName", name: "First Name" },
    { uid: "LastName", name: "Last Name" },
    { uid: "LoginName", name: "Login Name" },
    { uid: "Email_Id", name: "Email Id" },
    { uid: "Contact_No", name: "Contact No" },
  ]
 
  const onClickPrevPage = () => {
    dispatch(resetUserMaster())
    navigate(linksUrl.clientMaster.read)
  }

  const {
    isLoading,
    isError,
    data = [],
  } = useFetchWithBody({
    url: apiRoute.userMaster.read,
    queryKey: "UserMaster",
    inputData: {
      client_code: selectedClient.client_code,
    },
  })

  const columns = [
    {
      name: "ACTIONS",
      uid: "menuActions",
    },
    { uid: "UserId", name: "User Id" },
    { uid: "FirstName", name: "First Name" },
    { uid: "LastName", name: "Last Name" },
    { uid: "LoginName", name: "Login Name" },
    { uid: "Email_Id", name: "Email Id" },
    { uid: "Contact_No", name: "Contact No" },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "menuActions",
    "UserId",
    "FirstName",
    "LastName",
    "LoginName",
    "Email_Id",
    "Contact_No",
  ]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        navigate(linksUrl.userMaster.add)
      },
      label: "Add User", 
    },
  ]

  

  const rowMenuActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} />,
      onClick: (item) => {
        dispatch(setCurrentUser(item))
        navigate(linksUrl.userMaster.edit)
      },
      label: "Edit Details",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faList} />,
      onClick: (item) => {
        dispatch(setCurrentUser(item))
        navigate(linksUrl.userMenuMapping.read)
      },
      label: "Menu",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  /*  */
  return (
    <div>
      <MainContainer
        pageName="User Master"
        breadcrumbs={["Client Master", "User Master"]}
        info={[
          ["Client", selectedClient.client_name, selectedClient.client_code],
        ]}
        prevPage={{
          show: true,
          onClick: onClickPrevPage,
        }}
      >
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}
          
          rowMenuActionBtn={rowMenuActionBtn}
          downloadFileName="User_Master"
          id="UserId"
        />
      </MainContainer>
    </div>
  )
}

export default UserMaster
